import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { MdSnackBar, UNIQUE_SELECTION_DISPATCHER_PROVIDER } from '@angular/material';
import { Global } from './global.service';

@Injectable()
export class HttpHandler {
  public error: any;
  constructor(
    // public snackBar: MdSnackBar,
    private global: Global,
    private http: HttpClient
  ) { }

  handleError(error: any): void {
    console.log(error);
    if (error) {
      try {
        if (error && JSON.stringify(error) == '{}') {
          return;
        }
        if (
          error.message == 'token失效' ||
          'token无效' == error.message ||
          'token失效' == error.message
        ) {
          console.log('您的账号已在别处登录');
        } else if (error.message) {
          console.log('error', error.message);
        } else {
          console.log('error', '请求失败：');
        }
      } catch (e) {
        if (error.code == '202') {
          return error;
        } else if (error.message) {
          console.log('error', error.message);
        }
      }
    }
  }

  get(url: string, header?: any): Promise<any> {
    return this.http
      .get(url, header)
      .toPromise()
      .then(
        (response) => {
          const data = response;
          return data;
        },
        (response) => {
          this.handleError(response);
          return {
            success: false,
            message: this.getErrorMessage(response),
            error: response
          };
        }
      )
      .catch((error) => {
        console.error('请求异常:', error);
        this.handleError(error);
        return {
          success: false,
          message: this.getErrorMessage(error),
          error: error
        };
      });
  }

  post(url: string, data: any, header?: any): Promise<any> {
    return this.http
      .post(url, data, header)
      .toPromise()
      .then(
        (response) => {
          const data = response;
          return data;
        },
        (response) => {
          // 处理 HTTP 错误响应
          this.handleError(response);

          // 返回一个标准的错误对象，确保调用方能正确处理
          return {
            success: false,
            message: this.getErrorMessage(response),
            error: response
          };
        }
      )
      .catch((error) => {
        // 处理网络错误或其他异常
        console.error('请求异常:', error);
        this.handleError(error);

        // 返回一个标准的错误对象
        return {
          success: false,
          message: this.getErrorMessage(error),
          error: error
        };
      });
  }

  // 获取友好的错误消息
  private getErrorMessage(error: any): string {
    if (error.status === 0) {
      return '网络连接失败，请检查网络或服务器状态';
    } else if (error.status === 502) {
      return '服务器网关错误，请稍后重试';
    } else if (error.status === 503) {
      return '服务暂时不可用，请稍后重试';
    } else if (error.status === 500) {
      return '服务器内部错误';
    } else if (error.status === 404) {
      return '请求的资源不存在';
    } else if (error.message) {
      return error.message;
    } else {
      return '请求失败，请稍后重试';
    }
  }

  delete(url: string, header?: any): Promise<any> {
    return this.http
      .delete(url, header)
      .toPromise()
      .then(
        (response) => {
          const data = response;
          return data;
        },
        (response) => {
          this.handleError(response);
          return {
            success: false,
            message: this.getErrorMessage(response),
            error: response
          };
        }
      )
      .catch((error) => {
        console.error('请求异常:', error);
        this.handleError(error);
        return {
          success: false,
          message: this.getErrorMessage(error),
          error: error
        };
      });
  }
}
